export enum OpenPositionStatus {
  Open = 0,
  Closed = 1,
}

export interface OpenPositionDto {
  id: string;
  positionTitle: string;
  department: string;
  jobDescription: string;
  requirements: string;
  status: OpenPositionStatus | "Open" | "Closed" | "0" | "1";
  createdDate: string;
  createdBy: string;
}

export interface CreateOpenPositionDto {
  positionTitle: string;
  department: string;
  jobDescription: string;
  requirements: string;
}

export interface UpdateOpenPositionDto extends CreateOpenPositionDto {
  id: string;
  status: OpenPositionStatus;
}
